import * as React from 'react';
import { FormControl as MuiFormControl } from '@material-ui/core';
import styled from 'styled-components';
var StyledFormControl = styled(MuiFormControl).withConfig({
  displayName: "FormControl__StyledFormControl",
  componentId: "sc-1qyoilg-0"
})(["", ""], function (props) {
  if (props.disabled) {
    return 'opacity: 0.5;';
  }
});

var FormControl = function FormControl(_ref) {
  var getBodySlot = _ref.getBodySlot,
      body = _ref.body,
      children = _ref.children,
      disabled = _ref.disabled,
      error = _ref.error,
      required = _ref.required;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  return /*#__PURE__*/React.createElement(StyledFormControl, {
    disabled: disabled,
    error: error,
    ref: bodyCb,
    required: required,
    size: "small",
    variant: "outlined"
  }, body, children);
};

export default FormControl;

try {
  FormControl.__docgenInfo = {
    description: '',
    displayName: 'FormControl',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the label, input and helper text should be displayed in a disabled state.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label should be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label will indicate that the input is required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map